import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { useSnackbar } from "notistack";
import {
  createLessonsAPIEndpoint,
  EndPoints,
} from "./../../../services/LessonAPI";
import GenerateCodes from "../components/Codes/GeneratesCodes";


function Codes() {
  const { enqueueSnackbar } = useSnackbar();
  const [lessons, setLessons] = useState([]);
 

  const fetchLessons = () => {
    createLessonsAPIEndpoint(EndPoints.getLessons)
      .fetch()
      .then((res) => setLessons(res.data))
      .catch((err) => {
        console.error("Failed to fetch lessons:", err);
        enqueueSnackbar("Failed to fetch lessons.", { variant: "error" });
      });
  };

  useEffect(() => {
    fetchLessons();
  }, []);

  return (
    <Box className="code-section">
      <Typography variant="h3" className="title">
        Codes Management
      </Typography>

      <GenerateCodes lessons={lessons} />
    </Box>
  );
}

export default Codes;
